
(function ($) {
    $(window).on('load', function () {
        
        $(".accordion .wrapper .tab .title").off().on("click",function () {
            $(this).toggleClass("active");
            $(this).parent().find(".content").slideToggle(300);
            
        })

    });
})(jQuery);

